import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const HowItWorks = () => (
  <Section>
    <StaticQuery
      query={graphql`
        query HowItWorksHowItWorksHeroImageQuery {
          file(relativePath: { eq: "how_it_works.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 64% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 58% 50%;
              }
              @media screen and (min-width: ${getSize("tablet768")}) {
                object-position: 68% 50%;
              }
              @media screen and (min-width: ${getSize("tablet960")}) {
                object-position: 66% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize(
            "default"
          )}) and (max-width: 479px) {
          padding: 30px 38px 35px 38px;
        }
        @media screen and (min-width: ${getSize(
            "mobile480"
          )}) and (max-width: 719px) {
          padding: 31px 46px 46px 46px;
        }
        @media screen and (min-width: ${getSize(
            "tablet720"
          )}) and (max-width: 959px) {
          padding: 42px 40px 46px 42px;
          width: 362px;
        }
        @media screen and (min-width: ${getSize(
            "tablet960"
          )}) and (max-width: 1199px) {
          padding: 38px 38px 44px 42px;
          width: 400px;
        }
        @media screen and (min-width: ${getSize(
            "desktop1200"
          )}) and (max-width: 1919px) {
          padding: 40px 48px 44px 50px;
          width: 475px;
        }
        @media screen and (min-width: ${getSize("desktop1920")}) {
          padding: 76px 80px;
          width: 616px;
        }
      `}
    >
      <Header2>
        {"How it Works"}
        <Underlined />
      </Header2>
      <Paragraph
        css={`
          @media screen and (min-width: ${getSize(
              "default"
            )}) and (max-width: 479px) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "mobile480"
            )}) and (max-width: 719px) {
            margin-top: 21px;
          }
          @media screen and (min-width: ${getSize(
              "tablet720"
            )}) and (max-width: 959px) {
            margin-top: 22px;
          }
          @media screen and (min-width: ${getSize(
              "tablet960"
            )}) and (max-width: 1199px) {
            margin-top: 24px;
          }
          @media screen and (min-width: ${getSize("desktop1200")}) {
            margin-top: 22px;
          }
        `}
      >
        {
          "Simply pair a single Savant Power Companion Module with every two loads in your electrical panel and have the ability to monitor and control every circuit in your home or business. Then let Flexible Load Management optimize your energy production and consumption in every situation."
        }
      </Paragraph>
    </Card>
  </Section>
);
